export class TaskQueryParams {
    moduleName?: string;
}